import React from 'react';

import './App.css';
import { Keyboard } from './keyboard/Keyboard';

function App() {
  return (
    <div className="App">
      <Keyboard />
    </div>
  );
}

export default App;
